<template>
  <div ref="bannerContainer">
    <template v-if="bannerList && bannerList.length === 1">
      <img
          :src="bannerList[0].image"
          :style="{ width: '100%', height: swiperHeight, display: 'block' }"
          alt=""
          data-is-first="true"
          @load="onImageLoad($event)"
          @click="handleBannerJump(bannerList[0])"
      />
    </template>
    <template v-else>
      <div class="custom-banner-swiper-box">
        <div v-swiper:mySwiper="swiperOptions" class="swiper-container" :style="{ height: swiperHeight }">
          <div class="swiper-wrapper">
            <div
                class="swiper-slide"
                v-for="(item, index) in bannerList"
                :key="index"
                @click="handleBannerJump(item)"
            >
              <div class="reviewPicture-modelImg">
                <img
                    :src="item.image"
                    :data-is-first="index === 0"
                    alt=""
                    @load="onImageLoad($event, index)"
                />
              </div>
            </div>
          </div>
          <div v-show="isShowDot" class="custom-banner-swiper-pagination"></div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import { directive } from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'

export default {
  name: 'CustomBannerSwiper',
  directives: {
    swiper: directive
  },
  props: {
    bannerList: {
      type: Array,
      default: () => []
    },
    activeIndex: {
      type: Number,
      default: 0
    },
    isShowDot: {
      type: Boolean,
      default () {
        return true
      }
    },
    autoplay: {
      type: Boolean,
      default () {
        return false
      }
    },
    delay: {
      type: Number,
      default() {
        return 5000
      }
    }
  },
  data () {
    let autoplay = false
    if (this.autoplay) {
      autoplay = {
        delay: this.delay
      }
    }
    return {
      swiperOptions: {
        loop: true,
        autoplay: autoplay,
        pagination: {
          type: 'bullets',
          el: '.custom-banner-swiper-pagination', // 分页器所在的DOM节点，可以是CSS选择器或者DOM对象
          clickable: true // 允许点击分页器上的按钮跳转到对应的幻灯片
        },
        observer: true,
        observeParents: true
      },
      swiperHeight: 'auto', // 默认自动高度
      aspectRatio: null, // 存储第一张图片的宽高比（高度/宽度）
      isFirstImageLoaded: false // 标记第一张图片是否已加载
    }
  },
  watch: {
    bannerList: {
      handler(newVal) {
        if (newVal && newVal.length) {
          // 重置状态
          this.aspectRatio = null
          this.isFirstImageLoaded = false
          this.swiperHeight = 'auto'
        }
      },
      immediate: true
    }
  },
  mounted() {
    // 窗口变化重新计算高度
    window.addEventListener('resize', this.handleResize)
    // 如果图片已缓存，手动检查
    this.$nextTick(() => {
      this.checkFirstImageLoaded()
    })
  },
  methods: {
    handleBannerJump(item) {
      this.$emit('on-jump', item)
    },

    // 检查第一张图片是否已缓存
    checkFirstImageLoaded() {
      // 通过 data-is-first 精确定位第一张图，不能用 querySelectorAll('img')[0]：
      // Swiper loop 模式会克隆 slide（把最后一张克隆到最前面、第一张克隆到最后），DOM 顺序会被打乱
      const firstImg = this.$el?.querySelector('img[data-is-first="true"]')
      if (!firstImg) return

      if (firstImg.complete && firstImg.naturalWidth > 0) {
        this.onImageLoad({ target: firstImg })
      }
    },

    onImageLoad(e) {
      const img = e.target
      if (img.getAttribute('data-is-first') !== 'true' || this.isFirstImageLoaded) return
      const imgW = img.naturalWidth
      const imgH = img.naturalHeight

      if (!imgW || !imgH) {
        this.setSwiperHeight(300) // 使用默认高度
        return
      }

      // 保存宽高比（高度/宽度），最终高度 = 容器宽度 × 宽高比
      this.aspectRatio = imgH / imgW
      this.isFirstImageLoaded = true
      // 计算实际高度并设置
      this.calculateAndSetHeight()
    },

    calculateAndSetHeight() {
      if (!this.isFirstImageLoaded || !this.aspectRatio) return

      this.$nextTick(() => {
        // 获取容器实际宽度
        const container = this.$refs.bannerContainer || this.$el
        const rect = container.getBoundingClientRect()
        const containerWidth = rect?.width || window.innerWidth || 375

        if (!containerWidth || containerWidth <= 0) return

        // 高度 = 容器宽度 × 图片宽高比
        let finalHeight = containerWidth * this.aspectRatio
        finalHeight = Math.round(finalHeight * 100) / 100
        this.setSwiperHeight(finalHeight)
      })
    },

    setSwiperHeight(height) {
      const rounded = Math.round(height * 100) / 100
      const heightStr = rounded + 'px'

      if (heightStr !== this.swiperHeight) {
        this.swiperHeight = heightStr

        // 更新Swiper
        if (this.mySwiper && !this.mySwiper.destroyed) {
          this.$nextTick(() => {
            this.mySwiper.update()
          })
        }
      }
    },

    // 窗口变化重新计算
    handleResize() {
      if (this.isFirstImageLoaded) {
        this.calculateAndSetHeight()
      }
    }
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize)
    if (this.mySwiper && !this.mySwiper.destroyed) {
      this.mySwiper.destroy()
    }
  }
}
</script>

<style lang="less" scoped>
.custom-banner-swiper-box {
  position: relative;
  width: 100%;
  height: 100%;
  overflow: hidden;

  .swiper-container {
    width: 100%;
    height: 100%;
    transition: height 0.3s ease;

    .swiper-slide {
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }

  .reviewPicture-modelImg {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;

    img {
      width: 100%;
      height: 100%;
      object-fit: contain; // 保持比例，完整显示
      display: block;
    }
  }
}
</style>
<style lang="less">
.custom-banner-swiper-pagination {
  position: absolute;
  text-align: center;
  transition: 300ms opacity;
  transform: translate3d(0, 0, 0);
  z-index: 10;
  font-size: 0;
  line-height: 6px;
  &.swiper-pagination-bullets {
    bottom: 10px;
    height: 6px;
    & .swiper-pagination-bullet {
      width: 6px;
      height: 6px;
      background: #FFFFFF;
      opacity: .6;
    }
    & .swiper-pagination-bullet-active {
      border-radius: 6px;
      width: 16px;
    }
  }
}
</style>